export default class AlertType {
  public static readonly REGULAR = "e87d48f5-39b6-490b-b9f0-7990ad3558c4";
  public static readonly TAG_BASED = "bffcb473-b630-475a-8781-65338179ddca";
}
